import { render, staticRenderFns } from "./FavoriteSummary.vue?vue&type=template&id=feb234c2&scoped=true&"
import script from "./FavoriteSummary.vue?vue&type=script&lang=js&"
export * from "./FavoriteSummary.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteSummary.vue?vue&type=style&index=0&id=feb234c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb234c2",
  null
  
)

export default component.exports